export default {
  langName: 'English',
  login: {
    title: 'Login to SmartController',
    account: 'Username',
    password: 'Password',
    failed: 'Login failed.'
  },
  term: {
    title: 'Home',
    about: 'About',
    login: 'Login',
    logout: 'Logout',
    unknown: 'Unknown',
    defaultValue: 'Default value',
    preview: 'Preview',
    actions: 'Actions',
    // device
    tx: 'TX',
    rx: 'RX',
    loading: 'Loading...',
    online: 'Online',
    offline: 'Offline',
    uptime: 'Uptime',
    // dialog
    ok: 'Ok',
    save: 'Save',
    apply: 'Apply',
    cancel: 'Cancel',
    close: 'Close',
    reset: 'Reset',
    clear: 'Clear',
    discard: 'Discard',
    yes: 'Yes',
    no: 'No',
    delete: 'Delete',
    available: 'Available',
    unavailable: 'Unavailable',
    valid: 'Valid',
    invalid: 'Invalid',
    enabled: 'Enabled',
    disabled: 'Disabled',
    active: 'Active',
    inactive: 'Inactive',
    running: 'Running',
    stopped: 'Stopped',
    detected: 'Detected',
    undetected: 'Not detected',
    unused: 'Unpaired',
    filter: 'Filter',
    invalidSetting: 'Invalid setting',
    edit: 'Edit', // bindTo: 'Binded to...'
    editSetting: 'Change settings',
    status: 'Status',
    name: 'Name',
    name_help: 'For human readable',
    note: 'Note',
    rename: 'Rename',
    untitled: 'Untitled',
    selectAll: 'Select all',
    centering: 'Centering',
    create: 'Create',
    upload: 'Upload',
    really: 'Really?',
    next: 'Next',
    back: 'Back',
    finish: 'Finish',
    deleted: 'Deleted',
    error: 'Error',
    warning: 'Warning',
    applying: 'Applying...',
  },
  call: {
    vwNamed: 'VideoWall named "{0}"',
    osdNamed: 'OSD named "{0}"',
    imgNamed: 'image named "{0}"',
    presetNamed: 'preset named "{0}"',
    rx: {
      matrixFrom: 'from "{0}"',
      inVw: 'in "{0}"'
    },
    tx: {
      matrixTo: 'to {0} RX | to {0} RXs',
      inVw: 'to {0} RX | to {0} RXs'
    }
  },
  msg: {
    applyDone: 'Applied Successfully!',
    applyFailed: 'Error occurs, please try again later.',
    deleteConfirm: 'Are you sure to delete {0}?',
    nameCannotDuplicated: 'Name cannot be duplicated',
    nameIsRequired: 'Please input a name.',
    commingSoon: 'Comming soon...',
    clickAddToCreate: 'No item currently, click "+" at right-bottom corner to create new item.',
  },
  edidMode: {
    title: 'EDID Mode',
    fixed: 'Fixed',
    fixed_help: 'Choose a fixed EDID manually',
    fixed_desc: '({0})',
    learning: 'Learning',
    learning_help: 'Learning EDID information of TV from a RX',
    learning_desc: '(from "{0}")'
  },
  enum: {
    rotateFlip: {
      title: 'Rotate & Flip'
    }
  },
  modal: {
    dev: {
      details: {
        title: 'Detailed Information',
        id: 'Identification',
        network: 'Network',
        status: 'Status',
        io: 'I/O',
        av: 'Audio & Video',
        osd: 'OSD',
        advanced: 'Advanced features',
        version: 'Version',
      },
      rename: {
        title: 'Rename this Extender'
      },
      edid: {
        title: 'EDID of TX',
        description: 'For the plugged input source (e.g. a multimedia player), this TX plays the role of TV. TX can pretend to be a TV which supports a specific resolution via this EDID setting.',
        presetList: 'Preset List',
        learnFrom: 'Learn From...',
      },
    },
    networkError: {
      desc: 'Oops, network connection seems has some problem. Trying to reconnect now...',
      retryButton: 'Retry now'
    },
    closeConfirm: {
      title: 'Save modified settings?',
      desc: 'The settings without saving will be lost.',
    },
  },
  maintenance: {
    title: 'Maintenance',
    reboot: {
      title: 'Reboot',
      desc: 'Reboot this extender',
      prompt: 'Will reboot this extender, continue?'
    },
    resetToFactory: {
      title: 'Reset to factory',
      desc: 'Reset all configuration of this extender to factory',
      prompt: 'This action will clear all settings of this Extender, continue?'
    },
    blinkLed: {
      title: 'Blink LED',
      desc: 'Blink LED to let you know where this extender is',
      hasBeingBlinking: 'LED has already being blinking!',
      blinkedSuccessfully: 'Blink the LED of this device, please check it!'
    }
  },
  dev: {
    // System
    deviceName: 'Device Name',
    deviceType: 'Device Type',
    modelName: 'Model Name',
    serialNumber: 'Serial Number',
    uptime: 'Uptime',
    connectionTime: 'Connection Duration',
    groupID: 'Group ID',
    // Network
    mac: 'MAC Address',
    ip: 'IP Address',
    netmask: 'Subnet Mask',
    gateway: 'Gateway',
    multicastAddress: 'Multicast Address',
    lanStatus: 'LAN connected',
    baudRate: 'Baud rate',
    kBitRate: 'Bitrate',
    // AV
    audioMuteFlag: 'Disable audio playing',
    disableAVOutput: 'Disable video & audio playing',
    loopOut: 'Loop-out',
    loopOut_help: 'Duplicate the inputting signal into the loop-out HDMI port on TX.',
    clientSource: 'Signal source',
    // Standard
    cecFlag: 'CEC',
    cecFlag_help: 'CEC allows supported devices can communicate with & control each other via HDMI',
    edidMode: 'EDID Mode',
    hdcpStatus: 'HDCP',
    hdcpStatus_tx: 'Source HDCP status',  // NOTE: Inputting has HDCP
    hdcpStatus_rx: 'TV HDCP status',      // NOTE: TV supports HDCP  (Aspeed: "HDCP 1.4" | "HDCP 1.4 not supported")
    // Status
    txInputSourceDetected: 'Source HPD status',   // NOTE: Inputting A/V source detected
    rxTvConnectionDetected: 'TV HPD status',      // NOTE: TV plugged-in
    hdmiPlugged: 'HDMI Plugged',
    // Display
    upScaleMode: 'Upscale',
    osdResolution: '',
    rxCurrentResoultion: '',
    // Version
    series: 'Extender Series',
    series_short: 'Series',
    version: 'Version',
    rxVersion: 'RX Version',
    txVersion: 'TX Version',
    controlVersion: 'Control Version',
    encoderVersion: 'Encoder Version',
  },
  matrix: {
    title: 'Matrix',
    remap_tx: 'Deliver to RX...',
    remap_rx: 'Receive from TX...',
    cannotMapOfflineRx: 'Offlined RX cannot be mapped.',
    profileList: {
      save: {
        label: 'Save as profile',
        title: 'Save as Profile',
        desc: 'Save current state of Matrix as Profile.'
      },
      load: {
        label: 'Load from profile',
        title: 'Load from Profile',
        desc: 'Load Matrix state from a saved Profile.'
      },
      msg: {
        savedSuccess: 'Current mapping has been saved as "{0}" successfully.',
        loadedSuccess: 'Profile "{0}" has been loaded successfully.'
      }
    },
  },
  vw: {
    title: 'Video Wall',
    apply: 'Apply this Video Wall',
    list: {
      title: 'Video Wall List'
    },
    name: 'Name',
    id: 'ID',
    active: 'Enabled?',
    osd: 'Index OSD',  // TODO: move
    osd_help: 'Display index number on RX screen.', // TODO: move
    layout: 'Size',
    dragArea_help: 'Drag {0} to here',
    dragTxPlease_help: 'Please drag TX from TX List into VideoWall',
    dragRxPlease_help: 'This position has no RX yet; please drag RX from RX List into VideoWall',
    warnBeforeClearMappings: 'Modify this setting will clear all existing TX & RX mappings of this Video Wall.',
    removeSelected: 'Remove selected {0} from this VW',
    txMapper: {
      title: 'Allocate TX for this VideoWall',
      title_short: 'Allocate TX',
    },
    rxMapper: {
      title: 'Allocate RX for this VideoWall',
      title_short: 'Allocate RX',
    },
    create: {
      title: 'Create VideoWall'
    },
    resize: {
      title: 'Resize VideoWall'
    },
    vendor: {
      title: 'Change the Extender series of this Video Wall'
    },
    bezel: {
      title: 'Bezel',
    },
    rotateFlip: {
      title: 'Rotate & Flip',
    },
    delete: {
      title: 'Delete this VideoWall',
      desc: 'It will going to delete this VideoWall (but the settings of RX & TX themselves will not be affected)',
    },
    details: {
      title: 'Video Wall Details',
      mapping: 'Mappings',
      basic: 'Basic',
    },
    rename: {
      title: 'Rename Video Wall'
    },
    showDisplayIndex: {
      title: 'Show Index on each RX',
      help: 'Display index number on RX screen for indication.',
      warn: 'Warning: this function will clear the existing OSD of the RXs in this VideoWall.',
      show: 'Show index',
      hide: 'Hide index',
    }
  },
  deviceList: {
    title: 'Device List',
    viewMode: 'View Mode',
    info: 'Info...',
    rename: 'Rename',
    showingField: 'Info Field',
  },
  osd: {
    title: 'OSD',
    label: 'OSD',
    image: 'Image',
    text: 'Text',
    alignment: 'Alignment',
    content: 'Text content',
    shiftX: 'Shift horizontally',
    shiftY: 'Shift vertically',
    color: 'Color',
    fontSize: 'Font size',
    opacity: 'Opacity',
    select: 'Select an OSD',
    create: 'Create a new OSD',
    edit: 'Edit this OSD',
    cannotDeleteBecauseOccupiedByOther: 'Cannot delete this OSD, because this OSD is using by other settings:'
  },
  osdimg: {
    title: 'Image',
    select: 'Select an Image',
    create: 'Upload a new Image',
    edit: 'Edit Image Info',
    mask: 'Mask',
  },
  sys: {
    title: 'System',
    lang: {
      title: 'Language',
      auto: 'Auto',
      auto_help: 'Same with browser if possible',
    },
    ui: {
      title: 'User Interface'
    },
    basicinfo: {
      title: 'Information',
      status: 'Status',
      basicInfo: 'Basic Information',
      hwInfo: 'Hardware Information',
      versions: 'Versions',

      cpu: 'CPU Usage',
      ram: 'RAM Usage',
      disk: 'Disk Usage',

      upTime: 'Uptime',
      date: 'Date Time',
      name: 'Name',
      description: 'Description',
      location: 'Location',
      contact: 'Contact',
      macAddr: 'MAC Address',
      serialNumber: 'Serial Number',
      hardwareModel: 'Hardware Model',
      hardwareDescription: 'Hardware Description',
      swKernelVersion: 'Software Kernel Version',
      softwareVersion: 'Software Version',
      libVersion: 'Library Version',
      version: 'Version',
      vendor: 'Vendor',
      platform: 'Platform',
    },
    network: {
      title: 'Network',
      mode: 'Mode',
      static: 'Static (Manually)',
      dhcpClient: 'DHCP Client (Auto)',
      dns: 'DNS',
      requiredIfCloud: 'Required if you want to use Cloud functions',
    },
    maintenance: {
      title: 'Maintenance',
      reboot: 'Reboot',
      reboot_help: 'Reboot this Controller',
    }
  },
  thumbSize: {
    title: 'Thumbnail size',
    xs: 'Tiny',
    sm: 'Small',
    md: 'Medium',
    lg: 'Large',
    xl: 'Huge'
  },
  preset: {
    title: 'Presets',
    create: {
      title: 'Create a new preset',
      help: 'Please select the VideoWalls & Matrix you want to save to this preset. (Note: Only the RXs which is currently acting as Matrix can be found in Matrix list)',
      conflict: 'Some RXs are used in selected VideoWall or Matrix multiple times simultaneously, which cause conflict',
    },
    rename: {
      title: 'Rename this Preset',
    },
    apply: {
      title: 'Apply this Preset',
    },
    summary: {
      matrix: 'No Matrix | {0} Matrix | {0} Matrixes',
      vw: 'No VideoWall | {0} VideoWall | {0} VideoWalls',
    }
  },
  schedule: {
    title: 'Schedule'
  },
  validate: {
    osdTextCharSet: 'Only accepts alphabets, digits, dashes, underscore'
  },
  model: {
    hg: 'HG series (1G)',
    hx: 'HX series (10G)',
  },
}
